import { createAction } from '@reduxjs/toolkit';

export const EMPTY_ACTION = createAction<string>('emptyAction');
